import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';

import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ConciliacaoCartaoCreditoService } from '../../../../../shared/services/apis/financas/conciliacao-cartao-credito.service';
import { DesconciliarRequest } from '../../../../../shared/services/requests/financas/desconciliar.request';
import { ExtratoCartaoConciliadoItem } from '../../../../../shared/services/responses/financas/get-lancamentos-conciliados-cartao.response';

export enum TipoDesconciliacaoCartaoEnum {
    Simples = 1,
    Completo = 2,
}

export interface DesconciliarCartaoDialogData {
    extrato: ExtratoCartaoConciliadoItem;
}

@Component({
    selector: 'app-desconciliar-cartao-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatIconModule,
        AlertCardComponent,
        AbntPipe,
    ],
    templateUrl: './desconciliar-cartao-dialog.component.html',
    styleUrls: ['./desconciliar-cartao-dialog.component.css'],
})
export class DesconciliarCartaoDialogComponent {
    public TipoDesconciliacaoCartaoEnum = TipoDesconciliacaoCartaoEnum;
    public isSalvando = false;
    public tipoEmExecucao: TipoDesconciliacaoCartaoEnum | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DesconciliarCartaoDialogData,
        public dialogRef: MatDialogRef<DesconciliarCartaoDialogComponent>,
        private cartaoService: ConciliacaoCartaoCreditoService,
        private alertService: AlertService,
    ) { }

    get extrato(): ExtratoCartaoConciliadoItem {
        return this.data.extrato;
    }

    public cancelar(): void {
        if (this.isSalvando) return;
        this.dialogRef.close();
    }

    public confirmar(tipo: TipoDesconciliacaoCartaoEnum): void {
        if (this.isSalvando) return;
        this.isSalvando = true;
        this.tipoEmExecucao = tipo;
        this.dialogRef.disableClose = true;

        const request: DesconciliarRequest = {
            idExtratoBancario: this.extrato.idExtratoBancario,
            tipoDesconciliacao: tipo,
        };

        this.cartaoService.desconciliar(request).subscribe({
            next: res => {
                this.isSalvando = false;
                this.tipoEmExecucao = null;
                this.dialogRef.disableClose = false;
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription || 'Falha ao desconciliar.', AlertType.error);
                    return;
                }
                this.dialogRef.close({ sucesso: true });
            },
            error: err => {
                this.isSalvando = false;
                this.tipoEmExecucao = null;
                this.dialogRef.disableClose = false;
                this.alertService.show('Erro', err?.message || 'Erro inesperado.', AlertType.error);
            },
        });
    }
}
